import script from "./AdminSchoolsEditSchoolDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSchoolsEditSchoolDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__